import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import LandingGestaoTempo from './LandingPage/LandingGestaoTempo';

function App() {
  return (
    <LandingGestaoTempo affiliateLink="https://sun.eduzz.com/2424010?a=81765973" />
  );
}

export default App;
